import useHrComplianceMilestones from './useHrComplianceMilestones';

export default useHrComplianceMilestones;
